export default {
  functional: true,
  render(h, { props, children }) {
    const { disabled, locked, paused, checked, iconClass, to } = props

    const icon = h('i', { class: ['icon-link-icon', ...iconClass] })
    const text = h('span', { class: ['icon-link-text'] }, children)

    const tagName = disabled ? 'div' : 'router-link'

    const classNames = {
      'icon-link': true,
      'is-disabled': disabled,
      'is-locked': locked,
      'is-paused': paused,
      'is-checked': checked
    }

    return h(tagName, { class: classNames, attrs: { to } }, [icon, text])
  }
}
